import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import useConfigurationSummary from '../../../hooks/use-configuration-summary.js';
import ConfigurationSummary$1 from './ConfigurationSummary.js';

const ConfigurationSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const { frame , lensType , lensPackage , addOn , bundlePrice , hasVisitedStepAddOn , hasVisitedStepLensPackage ,  } = useConfigurationSummary();
    const labels = React.useMemo(()=>({
            lensType: getLabel('products.glasses.configurator.lensType'),
            lensPackage: getLabel('products.glasses.configurator.lensPackage'),
            addOn: getLabel('products.glasses.configurator.addOn'),
            totalPrice: getLabel('products.glasses.configurator.totalPrice'),
            zeroPrice: getLabel('products.glasses.configurator.priceIsZero')
        })
    , [
        getLabel
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    return /*#__PURE__*/ React.createElement(ConfigurationSummary$1, {
        frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn,
        bundlePrice: bundlePrice,
        labels: labels,
        isPhone: isPhone,
        isSmallScreen: isSmallScreen,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage,
        hasVisitedStepAddOn: hasVisitedStepAddOn
    });
};
var ConfigurationSummary = ConfigurationSummaryContainer;

export { ConfigurationSummary as default };
//# sourceMappingURL=ConfigurationSummaryContainer.js.map
